// extracted by mini-css-extract-plugin
module.exports = {"badges":"styles_badges__38LUX"};